export const TREECHAT_TOOLTIP_ID = 'treechat-global-tooltip'

/**
 * @param {string | null | undefined} content
 * @param {boolean} allowHtml
 */
export function normalizeTooltipContent(content, allowHtml = false) {
    if (!allowHtml || typeof content !== 'string') return content

    return content.replace(/<br\s*\/?>/gi, '\n')
}

/**
 * @param {{
 *   content?: string | null,
 *   allowHtml?: boolean,
 *   place?: import('react-tooltip').PlacesType,
 *   offset?: number,
 *   delayShow?: number,
 * }} options
 */
export function buildTooltipAnchorProps({
    content,
    allowHtml = false,
    place = 'bottom',
    offset = 0,
    delayShow = 1000,
}) {
    return {
        'data-tooltip-id': TREECHAT_TOOLTIP_ID,
        'data-tooltip-content': normalizeTooltipContent(content, allowHtml),
        'data-tooltip-place': place,
        'data-tooltip-offset': offset,
        'data-tooltip-delay-show': delayShow,
    }
}

/**
 * Anchor props for a hover tooltip, or none on a touch layout. A tap leaves a
 * sticky hover behind on touch screens, so a hover tooltip would open a second
 * later over whatever the reader reaches for next. Imperative tooltips
 * (openTooltip / showTooltipConfirmation) still anchor to the element.
 *
 * @param {Parameters<typeof buildTooltipAnchorProps>[0]} options
 * @param {{ touchLayout?: boolean }} layout
 */
export function buildHoverTooltipAnchorProps(options, { touchLayout = false } = {}) {
    return touchLayout ? {} : buildTooltipAnchorProps(options)
}
